// console.log("Maxilite Global: ");

// Single place to point the asset proxy. Swapping hosts is a one-line change.
const MAXILITE_PROXY_BASE = 'https://proxy-worker.maxilitecloudsolutions.store';

// Memoises live file-existence checks for the lifetime of the page.
// displayDownloadsModalButton() re-runs on every variant change and several of
// the URLs it checks (dimming sheet, colour swatch, product info) are identical
// across variants, so without this the same HEAD request is repeated on each
// click. Values are promises, which also collapses concurrent duplicate checks.
const maxiliteFileExistsCache = new Map();

// Proxy debug logging. Silence it from the browser console with:
//   localStorage.setItem('maxilite_proxy_debug', '0')   (then reload)
// and turn it back on with '1'. Reads are wrapped because localStorage throws
// in some privacy modes.
const MAXILITE_PROXY_DEBUG = (() => {
  try {
    return localStorage.getItem('maxilite_proxy_debug') !== '0';
  } catch {
    return true;
  }
})();

function proxyLog(...args) {
  if (MAXILITE_PROXY_DEBUG) {
    console.log('%c[maxilite-proxy]', 'color:#5794dd;font-weight:600', ...args);
  }
}

// X-Proxy-Cache tells you whether the edge served it (HIT), fetched and stored
// it (MISS), or deliberately skipped the cache (BYPASS — always the case for
// existence checks). It is readable cross-origin because the worker lists it in
// Access-Control-Expose-Headers.
function proxyStats(response, startedAt) {
  return {
    status: response.status,
    ms: Math.round(performance.now() - startedAt),
    edge: response.headers.get('X-Proxy-Cache') || 'n/a',
    reqId: response.headers.get('X-Request-Id') || 'n/a',
  };
}

const cleanupDownloadButtons = () => {
  const modalButtons = document.querySelectorAll('.custom-download-button-modal');
  modalButtons.forEach(button => {
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);
  });
  // const mainButton = document.getElementById('downloads-modal-button');
  // mainButton.style.display = 'none';
};

async function displayDownloadsModalButton(sku, download1_url, finish) {
  async function getProductHandleBySku(sku) {
    console.log("Getting handle for SKU: ", sku);
    const response = await fetch(`https://absent-rebeka-jarochosdev-54090cc3.koyeb.app/search?sku=${sku}`);
    const data = await response.json();
    
    console.log("Handle from sku original: ", data.handle);
    const processedHandle = data.handle.toLowerCase().replace(/\s+/g, "_");

    console.log("Handle from sku with lowercase and spaces replaced: ", processedHandle);
    return processedHandle;
  }

  // Live existence check, straight against the origin via the proxy.
  //
  // This replaces the previous approach, which pulled a full file manifest from
  // gather-all-files and cached it in localStorage for 30 minutes — so a newly
  // published PDF stayed invisible for up to half an hour, and line drawings
  // were missing from the manifest entirely and needed a separate checker.
  // A HEAD through the proxy is always current, and /api/proxy/head is never
  // edge-cached, so the answer reflects the origin right now.
  async function checkFileExists(url) {
    const cached = maxiliteFileExistsCache.get(url);
    if (cached) return cached;

    const check = (async () => {
      const startedAt = performance.now();
      try {
        const response = await fetch(
          `${MAXILITE_PROXY_BASE}/api/proxy/head?url=${encodeURIComponent(url)}`
        );
        proxyLog(
          response.ok ? '✓ exists' : '✗ missing',
          url.split('/').pop(),
          proxyStats(response, startedAt)
        );
        return response.ok; // Return true if the file exists
      } catch (error) {
        proxyLog('! check failed', url, error);
        console.error(`Error checking file existence for ${url}:`, error);
        return false; // Assume file does not exist if there's an error
      }
    })();

    maxiliteFileExistsCache.set(url, check);
    return check;
  }

  async function downloadFile(url, filename) {
    const startedAt = performance.now();
    try {
      const response = await fetch(`${MAXILITE_PROXY_BASE}/api/proxy?url=${encodeURIComponent(url)}`);
      if (!response.ok) {
        proxyLog('! download failed', filename, proxyStats(response, startedAt));
        throw new Error(`Failed to fetch file: ${response.statusText}`);
      }
      const stats = proxyStats(response, startedAt);
      const blob = await response.blob();
      proxyLog('⬇ downloaded', filename, {
        ...stats,
        kb: Math.round(blob.size / 1024),
        totalMs: Math.round(performance.now() - startedAt),
      });
      const downloadUrl = window.URL.createObjectURL(blob);

      // Create a temporary anchor element to trigger download
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      console.log(`Downloaded: ${filename}`);
    } catch (error) {
      console.error(`Error downloading file from ${url}:`, error);
      alert(`Error downloading file: ${filename}`);
    }
  }

  async function setupButton(button, url, filename) {
    const exists = await checkFileExists(url); // Check if the file exists
    if (!exists) {
      button.style.display = 'none'; // Hide button if file doesn't exist
      return false;
    }

    button.style.display = 'flex';
    button.addEventListener('click', async (event) => {
      event.preventDefault();
      await downloadFile(url, filename); // Trigger the download when clicked
    });
    return true;
  }

  // Specifications Button
  const specsButton = document.getElementById('downloads-modal-button-1');
  if (specsButton) {
    specsButton.style.display = 'flex';
    specsButton.addEventListener('click', (event) => {
      event.preventDefault();
      console.log('Specifications Sheet clicked');
      generatePDF(); // Call the function to generate the PDF
    });
  }

  // Dimming sheet varies by SKU prefix.
  let dimmingPdfName = null;
  if (sku.toUpperCase().startsWith('MXD')) {
    dimmingPdfName = 'elv_dimming.pdf';
  } else if (sku.toUpperCase().startsWith('MXA')) {
    dimmingPdfName = 'elv_triac_dimming.pdf';
  } else if (sku.toUpperCase().startsWith('MXL')) {
    dimmingPdfName = '0-10v_dimming.pdf';
  }

  const productHandle = await getProductHandleBySku(sku) || null;
  const iesHandle = productHandle ? productHandle.toLowerCase().replace(/\s+/g, '_') : null;
  const familySlug = document
    .getElementById('current-product-specs-family')
    ?.getAttribute('current-specs-family')
    ?.toLowerCase()
    .replace(/\s+/g, '_');

  const EXTRA_FILES = 'https://maxilitelighting.com/extra_files';
  const INSTRUCTIONS = 'https://maxilitelighting.com/instructions';
  const LINE_DRAWINGS = 'https://maxilitelighting.com/line_drawings';
  const IES_FILES = 'https://maxilitelighting.com/ies';

  // Each entry is [elementId, url, filename]; a null url means we lack the data
  // to build one, so that button is left untouched.
  //
  // These are gathered and resolved together rather than awaited one after
  // another: every entry now costs a network round-trip, and this whole
  // function re-runs on each variant change, so running them in series would
  // stack ten sequential requests onto every click.
  const downloadTargets = [
    ['downloads-modal-button-2', dimmingPdfName && `${EXTRA_FILES}/${dimmingPdfName}`, dimmingPdfName],
    ['downloads-modal-button-3', productHandle && `${INSTRUCTIONS}/instructions_${productHandle}.pdf`, `instructions_${productHandle}.pdf`],
    ['downloads-modal-button-3_2', productHandle && `${INSTRUCTIONS}/instructions_${productHandle}_2.pdf`, `instructions_${productHandle}_2.pdf`],
    ['downloads-modal-button-3_3', productHandle && `${INSTRUCTIONS}/instructions_${productHandle}_3.pdf`, `instructions_${productHandle}_3.pdf`],
    ['downloads-modal-button-4', finish === 'Custom Finish' ? `${EXTRA_FILES}/color_swatch.pdf` : null, 'color_swatch.pdf'],
    ['downloads-modal-button-5', familySlug && `${EXTRA_FILES}/product_info_${familySlug}.pdf`, `product_info_${familySlug}.pdf`],
    ['downloads-modal-button-5_2', productHandle && `${LINE_DRAWINGS}/line_drawing_${productHandle}.pdf`, `line_drawing_${productHandle}.pdf`],
    ['downloads-modal-button-6', iesHandle && `${IES_FILES}/${iesHandle}.ies`, `${iesHandle}.ies`],
    ['downloads-modal-button-6_2', iesHandle && `${IES_FILES}/${iesHandle}_2.ies`, `${iesHandle}_2.ies`],
    ['downloads-modal-button-6_3', iesHandle && `${IES_FILES}/${iesHandle}_3.ies`, `${iesHandle}_3.ies`],
    ['downloads-modal-button-6_4', iesHandle && `${IES_FILES}/${iesHandle}_4.ies`, `${iesHandle}_4.ies`],
  ];

  const waveStartedAt = performance.now();
  const cachedBefore = maxiliteFileExistsCache.size;

  const outcomes = await Promise.all(
    downloadTargets.map(([elementId, url, filename]) => {
      const button = document.getElementById(elementId);
      if (!button || !url) return null;
      return setupButton(button, url, filename);
    })
  );

  const attempted = outcomes.filter((r) => r !== null);
  proxyLog(
    `modal ready for ${sku}:`,
    `${attempted.filter(Boolean).length}/${attempted.length} files available,`,
    `${maxiliteFileExistsCache.size - cachedBefore} new checks,`,
    `${Math.round(performance.now() - waveStartedAt)}ms`
  );

  const modal = document.getElementById('downloads-modal');
  const mainButton = document.getElementById('downloads-modal-button');

  if (mainButton) {
    // mainButton.style.display = 'flex';
    mainButton.addEventListener('click', () => {
      modal.style.display = 'block';
    });
  }

  // Modal Close Logic
  const closeButton = document.querySelector('.close');
  closeButton.addEventListener('click', () => {
    modal.style.display = 'none';
  });

  window.addEventListener('click', (event) => {
    if (event.target === modal) {
      modal.style.display = 'none';
    }
  });
}


window.updateVariantAlternative = function () {
  const fieldsets = document.querySelectorAll('fieldset.js.product-form__input.maxilite');

  fieldsets.forEach((fieldset) => {
    const inputs = fieldset.querySelectorAll('input');

    inputs.forEach((input) => {
      const label = fieldset.querySelector(`label[for="${input.id}"]`);
      if (label) {
        label.classList.remove('visually-hidden');
      }
    });
  });

  setTimeout(() => {
    const fieldsets = document.querySelectorAll('fieldset.js.product-form__input.maxilite');
    fieldsets.forEach((fieldset) => {
      const disabledInputs = fieldset.querySelectorAll('input.disabled');
      disabledInputs.forEach((input) => {
        const label = fieldset.querySelector(`label[for="${input.id}"]`);
        if (label) {
          label.classList.add('visually-hidden');
        }
      });
    });
  }, 200);
};

function updateVariantOptions() {

  const fieldsets = document.querySelectorAll('fieldset.js.product-form__input.maxilite');

  fieldsets.forEach((fieldset) => {
    // First target all inputs within the fieldset and reset the display style
    const inputs = fieldset.querySelectorAll('input');

    inputs.forEach((input) => {
        // Find the corresponding label using the input's id
        const label = fieldset.querySelector(`label[for="${input.id}"]`);

        if (label) {
            // Explicitly reset the inline style for display
            label.classList.remove('visually-hidden');// Clear any inline 'display: none' set
        }
    });
});

  setTimeout(() => {
    const fieldsets = document.querySelectorAll('fieldset.js.product-form__input.maxilite');
    // Iterate over each fieldset
  

    fieldsets.forEach((fieldset) => {
        
        // Then handle disabled inputs specifically
        const disabledInputs = fieldset.querySelectorAll('input.disabled');
      

        disabledInputs.forEach((input) => {
            // Find the corresponding label using the input's id
            const label = fieldset.querySelector(`label[for="${input.id}"]`);

            if (label) {
                // Hide the label by setting display to 'none'
                label.classList.add('visually-hidden');
            }
        });

        
    });
}, 200); // 2000 milliseconds = 2 seconds


}



//check height and hide btn showmore
 function checkFinalHight(fHeight){
  const finalHeight = fHeight;
  const initialHeight = 405;

  const showmoreBtn = document.getElementById("specs-tbn_showmore");
  const masrecursos = document.getElementById("masrecursos-id");


      const tabladiv = document.getElementById("tabla--div");
    // console.log("offsetHeight of #tabla--div:", tabladiv.offsetHeight + "px");

  if(finalHeight <= initialHeight){
    showmoreBtn.style.display = "none"
    masrecursos.classList.remove("shadow");
    if(finalHeight > 375){
      tabladiv.style.maxHeight = `${initialHeight}px`;
    }
  } else{
    showmoreBtn.style.display = "block"
    masrecursos.classList.add("shadow");
  }

 }


//handle hide lines spacers
function setTableRowsVisibility(lineClass, shouldShow) {
  // Select all elements with both the spacer class and the specified line class
  const rows = document.querySelectorAll(`.spacer.${lineClass}, .spacer-line.${lineClass}`);
  
  // Determine the display value based on the shouldShow variable
  const displayValue = shouldShow ? '' : 'none';
  
  // Loop through the NodeList and set the display style accordingly
  rows.forEach(row => {
    row.style.display = displayValue;
  });
}


async function fetchRedisData() {
  try {
      const response = await fetch('https://woker-api-collections.maxilitecloudsolutions.store/redis', {
          method: 'GET',
          headers: {
              'Authorization': 'Bearer mysecret-key', // Replace with the actual key
              'Content-Type': 'application/json'
          }
      });

      if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
    // console.log("Returning data");
      return data;
  } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
  }
}


async function getReplacementCollection() {

  // Check if data is already cached in sessionStorage
  const cachedProducts = sessionStorage.getItem('products');
  if (cachedProducts) {
    // console.log('Returning cached products', JSON.parse(cachedProducts));
    return JSON.parse(cachedProducts);
  }

  try {
    const data = await fetchRedisData();
    sessionStorage.setItem('products', JSON.stringify(data.products));
    // console.log("Redis data: ", data.products);
    return data.products;
  } catch (error) {
    console.log("Error fetching data: ", error)
  }
}



// Function to update the bundle section
function bundleSection(bundleQty,bundleUnitPrice,bundleSectionID ){
  const bundleQt = parseFloat(bundleQty);

  // const testUnitPrice = "20.35";
  // const bundleUnitP = parseFloat(testUnitPrice);
  
  const bundleUnitP = parseFloat(bundleUnitPrice);
  const bundleUnitPriceFormated = bundleUnitP.toFixed(2);
  
  const bundlePrice = bundleQt * bundleUnitP;

  // Check if the decimal part is not zero
  const bundlePriceFormated = (bundlePrice % 1 !== 0) ? bundlePrice.toFixed(2) : bundlePrice;

  const BundleElementDiv = document.getElementById(bundleSectionID);
 if(BundleElementDiv){
  BundleElementDiv.innerHTML = `
  <div class="product-bundle">
    <p class="product-bundle__text">BUNDLE AND SAVE</p>
    <p class="product-bundle__promo">${bundleQt} pieces for $${bundlePriceFormated} <span class="product-bundle__price">($${bundleUnitPriceFormated}/piece)</span></p>
  </div>`

 }


}

// Function to clear the bundle section
function clearBundleSection(bundleSectionID) {
  const BundleElementDiv = document.getElementById(bundleSectionID);
  if (BundleElementDiv) {
    BundleElementDiv.innerHTML = '';
    // console.log("BundleSection cleared");
  }
}

function clearDataSpecsTable() {
  // console.log("Cleaning Data");
  let rows = document.querySelectorAll('#product-specs-table tr[id]');
  rows.forEach(row => {
    row.innerHTML = '';
    row.style.display = 'none';
  });

   const showmoreBtn = document.getElementById("specs-tbn_showmore");
  const masrecursos = document.getElementById("masrecursos-id");
 
  showmoreBtn.style.display = "none"
  masrecursos.classList.remove("shadow");

  setTableRowsVisibility("line-3", false);
  setTableRowsVisibility("line-4", false);

}





// Function to display the finish in the specs table
function displaySpecsFinish(finish) {
  // Input validation
  if (!finish || typeof finish !== 'string') {
      console.error('Invalid finish parameter');
      return;
  }

  // Process the finish string
  const finishString = finish.toLowerCase()
      .replace(/ /g, '-')
      .replace(/\//g, '_') + '.jpg';
  
  // Construct the image URL
  const finishImage = `https://maxilitelighting.com/paint_swatches/${finishString}`;
  
  // Get the container row
  const finishRow = document.getElementById("row-finish-swatch-image");
  if (!finishRow) {
      console.error('Could not find row-finish-swatch-image element');
      return;
  }

  // Create a new image element to check if the image exists
  const img = new Image();
  
  img.onload = function() {
      // Image loaded successfully, update the DOM
      finishRow.innerHTML = `
          <img src="${finishImage}" 
               alt="${finish}" 
               style="width: 100%; height: auto;"
               title="${finish}">`;
  };

  img.onerror = function() {
      // Image failed to load, display a fallback message or placeholder
      console.error(`Failed to load finish image for: ${finish}`);
      finishRow.innerHTML = `
          <div style="padding: 10px; text-align: center;">
              ${finish}
              <br>
              <small>(Swatch image not available)</small>
          </div>`;
  };

  // Start loading the image
  img.src = finishImage;
}



//New Function update_specs
async function assingSpecsData() {
//Changing the whay we handle variables in this function
//Changing the specs_data and variant id to get handle inside this current function


//Moving the the getter from specs_data to the metafieldData
const metafieldData = await getMetafieldData();
const { currentVariant, sectionId } = await getProductPageAttributes();

  const current_variantID = currentVariant;
  // console.log("Variant ID: ", current_variantID);

//  console.log("Assigning Specs Data: ");


  const skuObject = getSkuData();
  const sku = skuObject;
  const {
    finish,
    shade,
    glass,
    replacement_glass,
    replacement_glass_2,
    replacement_glass_3,
    variant_description: desc,
    dimming_percentage: dim_percentage,
    type_of_dimmer: dim_type,
    cri,
    optional_cri: optCri,
    lamping,
    led_life,
    "24_7_led_life": led_life24,
    color_temp,
    color_temp_option,
    width,
    height,
    length,
    max_width,
    max_height,
    max_length,
    width_mm,
    height_mm,
    length_mm,
    max_width_mm,
    max_height_mm,
    max_length_mm,
    suspension,
    extension,
    max_extension,
    canopy_width,
    canopy_height,
    canopy_length,
    canopy_diameter,
    wattage,
    delivered_lumens,
    included_count: incl_count,
    included_desc: incl_desc,
    required_count: req_count,
    required_desc: req_desc,
    required_shape: req_shape,
    location: loc,
    led_type,
    warranty,
    certification,
    voltage,
    optional_voltage: opt_voltage,
    made_in_canada,
    download1_name,
    download1_url,
    download2_name,
    download2_url,
    download3_name,
    download3_url,
    download4_name,
    download4_url,
    availability,
    special_instructions,
    hasQuickShip: hasQuickShipment,
    quick_ship_qty: quickShopStock,
    ship_time: hasQuickShipTime,
    bundleQty,
    bundleUnitPrice,
    gtin,
  } = metafieldData;

  // console.log("BundleQty: ",bundleQty);
  // console.log("BundleUnitPrice: ",bundleUnitPrice);
  if(bundleQty && bundleUnitPrice){
    const bundleSectionID = "BundlePromo"
    bundleSection(bundleQty, bundleUnitPrice, bundleSectionID);
  } else {
    clearBundleSection("BundlePromo");
  }

  
   displaySpecsFinish(finish);
  

  displayDownloadsModalButton(sku, download1_url, finish);
 

  updateVariantOptions();

  //console.log("Object destructuring complete");
  //console.log(finish);

 // console.log("Updating specs");

  //Getting Metafield Data:

  // console.log("Metafield Data:", metafieldData);

//  const { imageUrl, hasFeatureImage } = getFeaturedImage();
  //console.log("Featured Image: ", imageUrl);
  //console.log("Has Featured Image: ", hasFeatureImage);

  //QuickShipCode

//   //console.log("--------QuickShip Info ----- " + hasQuickShipment);
//   if (hasQuickShipment === "true") {
//     // console.log("This product has quickshipment " + hasQuickShipment);
//     if (quickShopStock) {
//       document.getElementById("maxi-StockShip").textContent = quickShopStock;
//       // console.log("Stock:" + quickShopStock);
//     } else {
//       document.getElementById("maxi-StockShip").textContent =
//         "Info unavailable. Please contact us for exact quantity info";
//       // console.log("Stock:" + quickShopStock);
//     }

//     if (hasQuickShipTime == null || hasQuickShipTime === "Contact us") {
//       //  console.log("Quick-Ship Time is:" + hasQuickShipTime);
//       document.getElementById("maxi-timeShiping").textContent =
//         "Contact us – This configuration will take longer to ship; we will provide a shipping date shortly. Select another option for next day shipping.";
//     } else {
//       document.getElementById("maxi-timeShiping").textContent =
//         hasQuickShipTime;
//       // console.log("Quick-Ship Time is:" + hasQuickShipTime);
//     }
//     document.getElementById("quick-maxi").style.display = "block";
//   } else {
//     // console.log("No Quickshipment Found ");
//     document.getElementById("quick-maxi").style.display = "none";
//   }

  // update main specs table
  const rowUpc = document.getElementById("row-upc");
  if (rowUpc) {
    if (gtin != null && String(gtin).trim() !== "") {
      const upcValue = String(gtin).split(".")[0];
      rowUpc.innerHTML = "<td>UPC</td><td>" + upcValue + "</td>";
      rowUpc.style.display = "table-row";
    } else {
      rowUpc.innerHTML = "";
      rowUpc.style.display = "none";
    }
  }
  if (sku != null) {
    document.getElementById("row-sku").innerHTML =
      "<td>Part Number</td><td>" + sku + "</td>";
    document.getElementById("row-sku").style.display = "table-row";
  } else {
    document.getElementById("row-sku").style.display = "none";
  }
  if (desc != null) {
    document.getElementById("container-desc").innerHTML = desc;
    document.getElementById("container-desc").style.display = "table-row";
  } else {
    document.getElementById("container-desc").innerHTML = "";
  }
  if (made_in_canada != null) {
    document.getElementById("row-made-in-canada").innerHTML =
      "<td>Made in Canada</td><td>" + made_in_canada + "</td>";
    document.getElementById("row-made-in-canada").style.display = "table-row";
  } else {
    document.getElementById("row-finish").style.display = "none";
  }
  if (finish != null) {
    document.getElementById("row-finish").innerHTML =
      "<td>Finish</td><td>" + finish + "</td>";
    document.getElementById("row-finish").style.display = "table-row";
  } else {
    document.getElementById("row-finish").style.display = "none";
  }
  if (shade != null) {
    document.getElementById("row-shade").innerHTML =
      "<td>Shade</td><td>" + shade + "</td>";
    document.getElementById("row-shade").style.display = "table-row";
  } else {
    document.getElementById("row-shade").style.display = "none";
  }
  if (glass != null) {
    document.getElementById("row-glass").innerHTML =
      "<td>Lens</td><td>" + glass + "</td>";
    document.getElementById("row-glass").style.display = "table-row";
  } else {
    document.getElementById("row-glass").style.display = "none";
  }
  
if (replacement_glass != null) {
    const replacementCollection = await getReplacementCollection();
    if(replacementCollection){
      // We are using the trim function to remove any white spaces from the string before replacing the spaces with a hyphen and converting the string to lowercase
      const searchHandle = replacement_glass.trim().replace(' ', '-').toLowerCase();
      const searchResult = replacementCollection.find(product => product.handle === searchHandle);
      if (searchResult) {
        const fullUrl = "https://maxilite.lighting/products/" + searchResult.handle;
         document.getElementById("row-replacement-glass").innerHTML =
            "<td>Replacement Lens</td><td><a href='" + fullUrl + "' style='color: #5794dd; font-weight: 600;'>" +
            replacement_glass +
            "<svg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 24 24' style='margin-left: 4px;'><path fill='#5794dd' d='M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83l1.41 1.41L19 6.41V10h2V3z'/></svg></a></td>";
        document.getElementById("row-replacement-glass").style.display = "table-row";
      } else {
        document.getElementById("row-replacement-glass").innerHTML =
        "<td>Replacement Lens</td><td>" + replacement_glass + "</td>";
         document.getElementById("row-replacement-glass").style.display =
        "table-row";
      }
    } else{
      document.getElementById("row-replacement-glass").innerHTML =
      "<td>Replacement Lens</td><td>" + replacement_glass + "</td>";
       document.getElementById("row-replacement-glass").style.display =
      "table-row";
    }

  } else {
    document.getElementById("row-replacement-glass").style.display = "none";
  }

   if (replacement_glass_2 != null) {
    const replacementCollection = await getReplacementCollection();
   
    if(replacementCollection){
      const searchHandle = replacement_glass_2.trim().replace(' ', '-').toLowerCase();
      const searchResult = replacementCollection.find(product => product.handle === searchHandle);
      if (searchResult) {
        const fullUrl = "https://maxilite.lighting/products/" + searchResult.handle;
        document.getElementById("row-replacement-glass2").innerHTML =
            "<td>Replacement Lens 2</td><td><a href='" + fullUrl + "' style='color: #5794dd; font-weight: 600;'>" +
            replacement_glass_2 +
            "<svg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 24 24' style='margin-left: 4px;'><path fill='#5794dd' d='M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83l1.41 1.41L19 6.41V10h2V3z'/></svg></a></td>";
        document.getElementById("row-replacement-glass2").style.display = "table-row";
      } else {
        document.getElementById("row-replacement-glass2").innerHTML =
        "<td>Replacement Lens 2</td><td>" + replacement_glass_2 + "</td>";
         document.getElementById("row-replacement-glass2").style.display =
        "table-row"; 
      } 
    } else{
      document.getElementById("row-replacement-glass2").innerHTML =
      "<td>Replacement Lens 2</td><td>" + replacement_glass_2 + "</td>";
       document.getElementById("row-replacement-glass2").style.display =
      "table-row";
    }

  } else {
    document.getElementById("row-replacement-glass2").style.display = "none";
  }

  if (replacement_glass_3 != null) {
    const replacementCollection = await getReplacementCollection();
    
    if(replacementCollection){
      const searchHandle = replacement_glass_3.trim().replace(' ', '-').toLowerCase();
      const searchResult = replacementCollection.find(product => product.handle === searchHandle);
      if (searchResult) {
        const fullUrl = "https://maxilite.lighting/products/" + searchResult.handle;
        document.getElementById("row-replacement-glass3").innerHTML =
            "<td>Replacement Lens 3</td><td><a href='" + fullUrl + "' style='color: #5794dd; font-weight: 600;'>" +
            replacement_glass_3 +
            "<svg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 24 24' style='margin-left: 4px;'><path fill='#5794dd' d='M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83l1.41 1.41L19 6.41V10h2V3z'/></svg></a></td>";
        document.getElementById("row-replacement-glass3").style.display = "table-row";
      } else {
        document.getElementById("row-replacement-glass3").innerHTML =
        "<td>Replacement Lens 3</td><td>" + replacement_glass_3 + "</td>";
         document.getElementById("row-replacement-glass3").style.display =
        "table-row"; 
      } 
    } else{
      document.getElementById("row-replacement-glass3").innerHTML =
      "<td>Replacement Lens 3</td><td>" + replacement_glass_3 + "</td>";
       document.getElementById("row-replacement-glass3").style.display =
      "table-row";
    }

  } else {
    document.getElementById("row-replacement-glass3").style.display = "none";
  }

  // dimensions
  var dimensions = [];
  if (width_mm != null) {
    if (width_mm != null) {
      let newWidth_mm = width_mm;
      if (newWidth_mm.endsWith(".0")) {
        newWidth_mm = newWidth_mm.slice(0, -2);
      }
      dimensions.push("W" + newWidth_mm + "mm"); 
    }
    if (height_mm != null) {
      let newHeight_mm = height_mm;
      if (newHeight_mm.endsWith(".0")) {
        newHeight_mm = newHeight_mm.slice(0, -2);
      }
      dimensions.push("H" + newHeight_mm + "mm");
    }
    if (length_mm != null) {
      let newLength_mm = length_mm;
      if (newLength_mm.endsWith(".0")) {
        newLength_mm = newLength_mm.slice(0, -2);
      }
      dimensions.push("L" + newLength_mm + "mm");
    }
  } else {
    if (width != null) {
      let newWidth = width;
      if (newWidth.endsWith(".0")) {
        newWidth = newWidth.slice(0, -2);
      }
      dimensions.push("W" + newWidth + "&Prime;");
    }
    if (height != null) {
      let newHeight = height;
      if (newHeight.endsWith(".0")) {
        newHeight = newHeight.slice(0, -2);
      }
      dimensions.push("H" + newHeight + "&Prime;");
    }
    if (length != null) {
      let newLength = length;
      if (newLength.endsWith(".0")) {
        newLength = newLength.slice(0, -2);
      }
      dimensions.push("L" + newLength + "&Prime;");
    }
    if (extension != null) {
      let newExtension = extension;
      if (newExtension.endsWith(".0")) {
        newExtension = newExtension.slice(0, -2);
      }
      dimensions.push("E" + newExtension + "&Prime;");
    }
  }

  if (dimensions.length > 0) {
    //if any dimensions exist in the array
    document.getElementById("row-dimensions").innerHTML =
      "<td>Dimensions</td><td>" + dimensions.join(" X ") + "</td>";
    document.getElementById("row-dimensions").style.display = "table-row";
  } else {
    document.getElementById("row-dimensions").style.display = "none";
  }

  // max dimensions
  var max_dimensions = [];
  if (max_width_mm != null) {
    if (max_width_mm != null) {
      let newMaxWidth_mm = max_width_mm;
      if (newMaxWidth_mm.endsWith(".0")) {
        newMaxWidth_mm = newMaxWidth_mm.slice(0, -2);
      }
      max_dimensions.push("W" + newMaxWidth_mm + "mm");
    }
    if (max_height_mm != null) {
      let newMaxHeight_mm = max_height_mm;
      if (newMaxHeight_mm.endsWith(".0")) {
        newMaxHeight_mm = newMaxHeight_mm.slice(0, -2);
      }
      max_dimensions.push("H" + newMaxHeight_mm + "mm");
    }
    if (max_length_mm != null) {
      let newMaxLength_mm = max_length_mm;
      if (newMaxLength_mm.endsWith(".0")) {
        newMaxLength_mm = newMaxLength_mm.slice(0, -2);
      }
      max_dimensions.push("L" + newMaxLength_mm + "mm");
    }
  } else {
    if (max_width != null) {
      let newMaxWidth = max_width;
      if (newMaxWidth.endsWith(".0")) {
        newMaxWidth = newMaxWidth.slice(0, -2);
      }
      max_dimensions.push("W" + newMaxWidth + "&Prime;");
    }
    if (max_height != null) {
      let newMaxHeight = max_height;
      if (newMaxHeight.endsWith(".0")) {
        newMaxHeight = newMaxHeight.slice(0, -2);
      }
      max_dimensions.push("H" + newMaxHeight + "&Prime;");
    }
    if (max_length != null) {
      let newMaxLength = max_length;
      if (newMaxLength.endsWith(".0")) {
        newMaxLength = newMaxLength.slice(0, -2);
      }
      max_dimensions.push("L" + newMaxLength + "&Prime;");
    }
    if (max_extension != null) {
      let newMaxExtension = max_extension;
      if (newMaxExtension.endsWith(".0")) {
        newMaxExtension = newMaxExtension.slice(0, -2);
      }
      max_dimensions.push("E" + newMaxExtension + "&Prime;");
    }
  }

  if (max_dimensions.length > 0) {
    //if ALL dimensions existcanopy_diameter
    document.getElementById("row-max-dimensions").innerHTML =
      "<td>Maximum Dimensions</td><td>" + max_dimensions.join(" X ") + "</td>";
    document.getElementById("row-max-dimensions").style.display = "table-row";
  } else {
    document.getElementById("row-max-dimensions").style.display = "none";
  }
  //Product url testing
  //https://maxilite.lighting/products/bar-36?variant=42265318162686

  //Canopy Dimentions

  const canopyDimentions = [];
  if (canopy_width != null) {
    if (canopy_width != null) {
      canopyDimentions.push("W" + canopy_width + "&Prime;");
    }
    if (canopy_height != null) {
      canopyDimentions.push("H" + canopy_height + "&Prime;");
    }
    if (canopy_length != null) {
      canopyDimentions.push("L" + canopy_length + "&Prime;");
    }
  }

  if (canopyDimentions.length > 0) {
    document.getElementById("row-canopy-dimensions").innerHTML =
      "<td>Canopy Dimensions</td><td>" + canopyDimentions.join(" X ") + "</td>";
    document.getElementById("row-canopy-dimensions").style.display =
      "table-row";
  } else {
    document.getElementById("row-canopy-dimensions").style.display = "none";
  }

  //Canopy Diameter
 // console.log("Product Description:",desc);
  //console.log("CanopyDiameter: ", canopy_diameter);
  if (canopy_diameter != null) {
    document.getElementById(
      "row-canopy-diameter"
    ).innerHTML = `<td>Canopy Diameter</td><td>${canopy_diameter}&Prime;</td>`;
    document.getElementById("row-canopy-diameter").style.display = "table-row";
  } else {
    document.getElementById("row-canopy-diameter").style.display = "none";
  }

  // suspension
  if (suspension != null) {
    document.getElementById("row-suspension").innerHTML =
      "<td>Suspension</td><td>" + suspension + "</td>";
    document.getElementById("row-suspension").style.display = "table-row";
  } else {
    document.getElementById("row-suspension").style.display = "none";
  }

  if (wattage != null) {

    let wattageNumber = parseFloat(wattage);
    let wattageString = String(wattage);

    if(wattageNumber % 1 === 0){
      wattageString = wattageNumber.toString();
    } else if(wattageNumber % 1 === 0.5){
      wattageString = wattageNumber.toFixed(1);
    } 
    // just display the wattage number by itself
    document.getElementById("row-wattage").innerHTML =
      "<td>Wattage</td><td>" + wattageString + "</td>";
    document.getElementById("row-wattage").style.display = "table-row";
  } else {
    // if wattage data does not exist
    document.getElementById("row-wattage").style.display = "none";
  }

  if (certification != null) {
    document.getElementById("row-certification").innerHTML =
      "<td>Certification</td><td>" + certification + "</td>";
    document.getElementById("row-certification").style.display = "table-row";
  } else {
    document.getElementById("row-certification").style.display = "none";
  }
  if (delivered_lumens != null) {
    let deliveredLumensNumber = parseFloat(delivered_lumens); 
    let deliveredLumensString = String(delivered_lumens);

    if(deliveredLumensNumber % 1 === 0){
      deliveredLumensString = deliveredLumensNumber.toString();
    } else if(deliveredLumensNumber % 1 === 0.5){
      deliveredLumensString = deliveredLumensNumber.toFixed(1);
    }

    document.getElementById("row-delivered-lumens").innerHTML =
      "<td>Delivered Lumens</td><td>" + deliveredLumensString + "</td>";
    document.getElementById("row-delivered-lumens").style.display = "table-row";
  } else {
    document.getElementById("row-delivered-lumens").style.display = "none";
  }

  //Disclaimer
  //If the product `Handle`|sku begins with MXA, MXD, or MXL, show this disclaimer
  if (sku.startsWith("MXA") || sku.startsWith("MXD") || sku.startsWith("MXL")) {
    document.getElementById("row-disclaimer").innerHTML =
      "<td></td><td>Disclaimer: Delivered Lumens are based on calculations – Please contact factory for IES Files if required.</td>";
    document.getElementById("row-disclaimer").style.display = "table-row";
  } else {
    document.getElementById("row-disclaimer").style.display = "none";
  }

  //DIMMING
  if (dim_percentage != null || lamping == "Incandescent") {
    //if there's a dim percentage OR incandescent
    document.getElementById("row-dimmable").innerHTML =
      "<td>Dimmable</td><td>Yes</td>";
    document.getElementById("row-dimmable").style.display = "table-row";
  } else {
    document.getElementById("row-dimmable").innerHTML =
      "<td>Dimmable</td><td>No</td>";
    document.getElementById("row-dimmable").style.display = "table-row";
  }
  if (dim_percentage != null) {
    //if there's a dim percentage
    document.getElementById("row-dim-percentage").innerHTML =
      "<tr><td>Dimming Percentage</td><td>" + dim_percentage + "</td></tr>";
    document.getElementById("row-dim-percentage").style.display = "table-row";
  } else {
    document.getElementById("row-dim-percentage").style.display = "none";
  }
  if (dim_type != null) {
    //if there's a dim type
    document.getElementById("row-dim-type").innerHTML =
      "<tr><td>Type of Dimmer</td><td>" + dim_type + "</td></tr>";
    document.getElementById("row-dim-type").style.display = "table-row";
  } else {
    document.getElementById("row-dim-type").style.display = "none";
  }

   //More Specs
  // Check if any of the variables 1 to 13 are not null
  if (cri || optCri || led_life || led_life24 || color_temp || color_temp_option || 
  loc || warranty || incl_count || req_count || certification || 
  voltage || opt_voltage) {
  // console.log("At least one of the variables 1 to 13 is not null.");
  setTableRowsVisibility("line-3", true);
  } else{
  setTableRowsVisibility("line-3", false);
  }

  
  if (cri != null) {

    let criNumber = parseFloat(cri);
    let criString = String(cri);

    if(criNumber % 1 === 0){
      criString = criNumber.toString();
    } else if(criNumber % 1 === 0.5){
      criString = criNumber.toFixed(1);
    } 

    document.getElementById("row-cri").innerHTML =
      "<td>CRI</td><td>" + criString + "</td>";
    document.getElementById("row-cri").style.display = "table-row";
  } else {
    document.getElementById("row-cri").style.display = "none";
  }
  // if (optCri != null) {
  //   document.getElementById("row-optcri").innerHTML =
  //     "<td>Optional CRI</td><td>" + optCri + "</td>";
  //   document.getElementById("row-optcri").style.display = "table-row";
  // } else {
  //   document.getElementById("row-cri").style.display = "none";
  // }
  if (led_life != null) {
    document.getElementById("row-led-life").innerHTML =
      "<td>LED Life</td><td>" + led_life + "</td>";
    document.getElementById("row-led-life").style.display = "table-row";
  } else {
    document.getElementById("row-led-life").style.display = "none";
  }
  if (led_life24 != null) {
    document.getElementById("row-24led-life").innerHTML =
      "<td>24/7 LED Life</td><td>" + led_life24 + "</td>";
    document.getElementById("row-24led-life").style.display = "table-row";
  } else {
    document.getElementById("row-24led-life").style.display = "none";
  }

if (color_temp != null) {
  console.log("Color Temperature: ", color_temp);
  
  // Convert the input to a string.
  let colorTempString = String(color_temp);
  
  // Check if the string represents a range or a special format (contains a dash or underscore)
  if (colorTempString.includes('-') || colorTempString.includes('_')) {
    // For range or special values like "27-30-35-40-50K" or "27_30_35", leave colorTempString unchanged.
    console.log("Detected range/special format: ", colorTempString);
  } else {
    // If it's not a range or special formatted string, try to parse it as a number.
    let colorTempNumber = parseFloat(color_temp);
    console.log("ColorTemNumber: ", colorTempNumber);
    
    // Check for formatting cases:
    if (colorTempNumber % 1 === 0) {
      // It's an integer.
      colorTempString = colorTempNumber.toString();
    } else if (colorTempNumber % 1 === 0.5) {
      // It has a fractional part of .5.
      colorTempString = colorTempNumber.toFixed(1);
    }
  }
  
  // Display the formatted value.
  document.getElementById("row-color-temp").innerHTML =
    "<td>Color Temperature</td><td>" + colorTempString + "</td>";
  document.getElementById("row-color-temp").style.display = "table-row";
} else {
  document.getElementById("row-color-temp").style.display = "none";
}
  if (color_temp_option != null) {
    document.getElementById("row-color-temp-option").innerHTML =
      "<td>Color Temperature Options</td><td>" + color_temp_option + "</td>";
    document.getElementById("row-color-temp-option").style.display =
      "table-row";
  } else {
    document.getElementById("row-color-temp-option").style.display = "none";
  }
   if (led_type != null) {
    document.getElementById("row-led-type").innerHTML =
      "<td>LED Type</td><td>" + led_type + "</td>";
    document.getElementById("row-led-type").style.display = "table-row";
  } else {
    document.getElementById("row-led-type").style.display = "none";
  }
  if (loc != null) {
    document.getElementById("row-location").innerHTML =
      "<td>Location</td><td>" + loc + "</td>";
    document.getElementById("row-location").style.display = "table-row";
  } else {
    document.getElementById("row-location").style.display = "none";
  }
  if (warranty != null) {
    document.getElementById("row-warranty").innerHTML =
      "<td>Warranty</td><td>" + warranty + "</td>";
    document.getElementById("row-warranty").style.display = "table-row";
  } else {
    document.getElementById("row-warranty").style.display = "none";
  }
  if (incl_count != null) {

    let inclCountNumber = parseFloat(incl_count);
    let inclCountString = String(incl_count);

    if(inclCountNumber % 1 === 0){
      inclCountString = inclCountNumber.toString();
    } else if(inclCountNumber % 1 === 0.5){
      inclCountString = inclCountNumber.toFixed(1);
    }
      
    

    // if bulbs included
    document.getElementById("row-bulbs-included").innerHTML =
      "<td>Bulbs Included</td><td>" + inclCountString + " X " + incl_desc + "</td>";
    document.getElementById("row-bulbs-included").style.display = "table-row";
    document.getElementById("row-bulbs-required").style.display = "none";
  } else if (req_count != null) {

    let reqCountNumber = parseFloat(req_count);
    let reqCountString = String(req_count);

    if(reqCountNumber % 1 === 0){
      reqCountString = reqCountNumber.toString();
    } else if(reqCountNumber % 1 === 0.5){
      reqCountString = reqCountNumber.toFixed(1);
    }
    

    // if bulbs ARE NOT included
    document.getElementById("row-bulbs-included").innerHTML =
      "<td>Bulbs Included</td><td>None</td>";
    document.getElementById("row-bulbs-required").innerHTML =
      "<td>Bulbs Required</td><td>" +
      reqCountString +
      " X " +
      req_desc +
      " " +
      req_shape +
      "</td>";
    document.getElementById("row-bulbs-included").style.display = "table-row";
    document.getElementById("row-bulbs-required").style.display = "table-row";
  } else {
    // if neither incl NOR req information exists
    document.getElementById("row-bulbs-included").style.display = "none";
    document.getElementById("row-bulbs-required").style.display = "none";
  }
  if (certification != null) {
    document.getElementById("row-certification").innerHTML =
      "<td>Certification</td><td>" + certification + "</td>";
    document.getElementById("row-certification").style.display = "table-row";
  } else {
  }
  if (voltage != null) {
   
    let numVoltage = parseFloat(voltage);
    let voltageString = String(voltage);

    if(numVoltage % 1 === 0){
      //convert back to string
      voltageString = numVoltage.toString();
    } else if(numVoltage % 1 === 0.5){
      //convert back to string
      voltageString = numVoltage.toFixed(1); 
    }

    document.getElementById("row-voltage").innerHTML =
      "<td>Voltage</td><td>" + voltageString + "</td>";
    document.getElementById("row-voltage").style.display = "table-row";
  } else {
    document.getElementById("row-voltage").style.display = "none";
  }
  if (opt_voltage != null) {
    let optVoltageNumber = parseFloat(opt_voltage);
    let optVoltageString = String(opt_voltage);

    if(optVoltageNumber % 1 === 0){
      optVoltageString = optVoltageNumber.toString();
    } else if(optVoltageNumber % 1 === 0.5){
      optVoltageString = optVoltageNumber.toFixed(1);
    }

    document.getElementById("row-opt-voltage").innerHTML =
      "<td>Optional voltage</td><td>" + optVoltageString + "</td>";
    document.getElementById("row-opt-voltage").style.display = "table-row";
  } else {
    document.getElementById("row-opt-voltage").style.display = "none";
  }

  //Special-instructions
  // Check if the variable 14 is not null
  if (special_instructions) {
  // console.log("The variable 'special_instructions' is not null.");
  setTableRowsVisibility("line-4", true);
  } else{
  setTableRowsVisibility("line-4", false);
  }

  if (special_instructions != null) {
    document.getElementById("special-instructions").innerHTML =
      "<h2 class='specs-table-heading'>Special Instructions</h2><p>" +
      special_instructions +
      "</p>";
    document.getElementById("special-instructions").style.display = "block";
  } else {
    document.getElementById("special-instructions").style.display = "none";
  }

  // //    Download 1 is always the _instructions.pdf file.
  // console.log("Download Url: ", download1_url); //https://maxilitelighting.com/instructions/mxa6318-02-instructions.pdf
  // if (download1_url != null) {
  //   var myRequest = new Request(download1_url);

  //   fetch(myRequest, { redirect: "manual" }).then(function (response) {
  //     if (response.status == 200) {
  //       document.getElementById("container-download1").innerHTML =
  //         "<a href='" +
  //         download1_url +
  //         "' target='_blank'>" +
  //         download1_name +
  //         "</a>";
  //       document.getElementById("container-download1").style.display = "block";
  //       console.log("url for download1_url exists");
  //     } else {
  //       document.getElementById("container-download1").style.display = "none";
  //       console.log("download1 url doesnt exist");
  //     }
  //   });
  // } else {
  //   document.getElementById("container-download1").style.display = "none";
  //   console.log("download1 url doesnt exist");
  // }

  async function fetchDownloadUrl() {
    // console.log("Download Url: ", download1_url);
   // Testing url: const newUrl = "//maxilite-manufacturing-ltd-2.myshopify.com/cdn/shop/files/mx-3382-40-instructions.pdf?v=134673462530664668"
    const containerDownload1 = document.getElementById("container-download1");
    if (download1_url != null && containerDownload1) {
      const proxyEndpoint = 'https://worker-cold-resonance-a135.librado-cruzmx.workers.dev'; 
      const proxyRequestData = {
        url: download1_url, // The URL you want to proxy to
        method: 'GET', // The HTTP method for the proxy request
        headers: { // Optional headers for the proxy request
          'Content-Type': 'application/json',
          // Add other headers as needed
        },
        data: null, // For GET requests, data is typically null. For POST, this would be your payload
      };
      // console.log("proxyRequestDATA: ",proxyRequestData)
      try {
        const response = await fetch(proxyEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(proxyRequestData),
        });

        if (!response.ok) {
          document.getElementById("container-download1").style.display = "none";
          // console.log("download1 url doesn't exist");
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
          const responseData = await response.json();
          // console.log("RESPONSE: ", responseData);
          if (responseData.isPdf) {
          document.getElementById("container-download1").innerHTML =
            `<a href='${download1_url}' target='_blank'>Download Instructions for ${sku}</a>`;
            // <a href='${download1_url}' target='_blank'>${download1_name}</a>`;
          document.getElementById("container-download1").style.display = "block";
          // console.log('The URL points to a PDF file.');
        } else {
          // Execute actions for when the URL is not a PDF
          // console.log('The URL does not point to a PDF file.');
          // Here, you might handle non-PDF content, display an alert, or any other relevant action.
        }
       
        } catch (error) {
          console.error('Request failed:', error);
        }
    } else if(containerDownload1) {
      document.getElementById("container-download1").style.display = "none";
      console.log("download1 url doesn't exist");
    }

  }
  
  fetchDownloadUrl();
  


  //reminder: only download1 needs an http request to check if url is valid, because
  //from Excelify spreadsheet these are full URLs.
  //for download2 and download3, all you need is to check if it's null because in
  //the Excelify spreadsheet, these one's will be BLANK.
  const containerDownload2 = document.getElementById("container-download2");
  if (download2_url != null && containerDownload2) {
    document.getElementById("container-download2").innerHTML =
      "<a href='https://www.maxilitelighting.com/extra_files/" +
      download2_url +
      "' target='_blank'>" +
      download2_name +
      "</a>";
    document.getElementById("container-download2").style.display = "block";
  } else if(containerDownload2){
    document.getElementById("container-download2").style.display = "none";
  }
  
  const containerDownload3 = document.getElementById("container-download3");
  if (download3_url != null && containerDownload3) {
    document.getElementById("container-download3").innerHTML =
      "<a href='https://www.maxilitelighting.com/extra_files/" +
      download3_url +
      "' target='_blank'>" +
      download3_name +
      "</a>";
    document.getElementById("container-download3").style.display = "block";
  } else if(containerDownload3){
    document.getElementById("container-download3").style.display = "none";
  }

  const containerDownload4 = document.getElementById("container-download4");
  if (download4_url != null) {
    document.getElementById("container-download4").innerHTML =
      "<a href='https://www.maxilitelighting.com/extra_files/" +
      download4_url +
      "' target='_blank'>" +
      download4_name +
      "</a>";
    document.getElementById("container-download4").style.display = "block";
  } else if(containerDownload4){
    document.getElementById("container-download4").style.display = "none";
  }

   const tablaDiv = document.getElementById("product-specs-table");
   const finalHeight = tablaDiv.offsetHeight;
    // console.log("Final height of product-specs-table:", finalHeight + "px");
 
  checkFinalHight(finalHeight)
  
}




//update_quoteform
function update_quoteform() {
  const cv_specs = getMetafieldData();
  // This function only happens once when the user clicks on the
  // request quote button. This avoids any of their work being
  // erased upon changing variant options!
  const sku = getSkuData();
  const { variant_description: desc } = cv_specs;
 // console.log("update_quoteform sku: ", sku);
//  console.log("update_quoteform desc: ", desc);
  // update data in contact form
  if (sku != null && desc != null) {
    document.getElementById("textarea-itemnumbers").innerHTML =
      sku + " (" + desc + ")";
  } else {
    document.getElementById("textarea-itemnumbers").innerHTML = "";
  }
}

//cv_specs
async function generatePDF() {
  // --- Helper Functions ---

  // Extracts data from table rows with a given sectionClass.
  // Optionally handles a disclaimer if 'hasDisclaimer' is passed for "row_section_2".
  async function extractTableData(sectionClass, hasDisclaimer) {
    const rows = document.querySelectorAll(`#product-specs-table .${sectionClass}`);
    const data = [];

    rows.forEach((row, index) => {
      const cells = row.querySelectorAll("td");
      if (cells.length === 2 && cells[0].textContent !== "") {
        data.push({
          key: cells[0].textContent,
          value: cells[1].textContent,
        });
      }
      // Handle the disclaimer at the last row if necessary
      if (index === rows.length - 1 && sectionClass === "row_section_2" && hasDisclaimer) {
        data.push({
          key: "disclaimer",
          value:
            "Disclaimer: Delivered Lumens are based on calculations – Please contact factory for IES Files if required.",
        });
      }
    });

    return data;
  }

  // Loads an image (Finish image) and adds it to the PDF.
  async function loadAndAddFinishImage(doc, imageUrl, x, y, maxWidth, alias = "FinishImage") {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";

      img.onload = () => {
        const roundY = Math.round(y);
        const aspectRatio = img.height / img.width;
        const imgWidth = Math.min(maxWidth, 80);
        const imgHeight = imgWidth * aspectRatio;

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        try {
          doc.addImage(
            canvas.toDataURL("image/jpeg"),
            "JPEG",
            x,
            roundY,
            imgWidth,
            imgHeight,
            alias,
            "SLOW"
          );
          resolve();
        } catch (error) {
          reject(error);
        }
      };

      img.onerror = reject;
      // Proxied so the canvas stays untainted: crossOrigin="Anonymous" above
      // needs an Access-Control-Allow-Origin on the response, or the
      // canvas.toDataURL() call in onload throws a SecurityError.
      img.src = `${MAXILITE_PROXY_BASE}/api/proxy?url=${encodeURIComponent(imageUrl)}`;
    });
  }

  // Looks up a felt swatch by SKU. Returns the reachable swatch object or null.
  async function fetchFeltSwatchData(sku) {
    if (!sku) return null;
    try {
      const res = await fetch(
        `https://fswatch-api.maxilitecloudsolutions.store/felt-swatches/search?q=${encodeURIComponent(sku)}`
      );
      if (!res.ok) return null; // 404 / non-2xx -> no swatch
      const data = await res.json();
      if (data && data.swatch && data.swatch.imageReachable === true && data.swatch.imageUrl) {
        return data.swatch; // whole object (has imageUrl + feltSwatch)
      }
      return null;
    } catch (e) {
      console.error("Failed to fetch felt swatch:", e);
      return null;
    }
  }

  // Fetches an image URL as a Blob, then creates and returns an ImageBitmap
  async function requestImage(imageUrl) {
    try {
      const response = await fetch(imageUrl);
      if (!response.ok) {
        throw new Error("Network response was not ok " + response.statusText);
      }
      const blob = await response.blob();
      const img = await createImageBitmap(blob);
      return img;
    } catch (error) {
      console.error("Failed to fetch the image:", error);
    }
  }

  // --- Main PDF generation logic ---

  try {
    // 1. Gather data and initial setups
    const cv_specs = getMetafieldData(); // Provided externally
    const sku = getSkuData();            // Provided externally
    const dataMetafields = cv_specs;
    const productPdfSku = sku;

    // Look up the felt swatch (by SKU) once; null if none/unreachable.
    const feltSwatchData = await fetchFeltSwatchData(sku);
    const feltSwatchImageUrl = feltSwatchData ? feltSwatchData.imageUrl : null;
    const feltSwatchText = feltSwatchData ? feltSwatchData.feltSwatch : null;

    // Decide whether to include disclaimer based on SKU
    const hasDisclaimer =
      sku.startsWith("MXA") || sku.startsWith("MXD") || sku.startsWith("MXL")
        ? true
        : undefined;

    // Extract data from each specs section
    const section1Data = await extractTableData("row_section_1");
    const section2Data = await extractTableData("row_section_2", hasDisclaimer);
    const section3Data = await extractTableData("row_section_3");
    const section4Data = await extractTableData("row_section_4");
    const section5Data = await extractTableData("row_section_5");
    const section6Data = await extractTableData("row_section_6");
    const section7Data = await extractTableData("row_section_7");

    // Canvas/Image references
    const canvas = document.getElementById("s1-canvas");
    const { imageUrl, hasFeatureImage } = getFeaturedImage(); // Provided externally

    // Initialize PDF
    const doc = new window.jspdf.jsPDF({ lineHeight: 1.5 });

    // 2. Title
    doc.setFont("helvetica", "bold");
    doc.setFontSize(30);


    //logo link url: https://cdn.shopify.com/s/files/1/0251/9964/0648/files/full-transparent_a943ee21-9b35-4518-b6ae-c2c302998f0d.png?v=1701128858  
    const logoUrl = "https://cdn.shopify.com/s/files/1/0251/9964/0648/files/full-transparent_a943ee21-9b35-4518-b6ae-c2c302998f0d.png?v=1701128858";
    const logoImage = await requestImage(logoUrl);
    // Convert the image to a data URL
    const canvasLogo = document.createElement('canvas');
    const ctx = canvasLogo.getContext('2d');
    canvasLogo.width = logoImage.width;
    canvasLogo.height = logoImage.height;
    ctx.drawImage(logoImage, 0, 0);

    // Add the image to the PDF
    doc.addImage(canvasLogo.toDataURL("image/png"), "JPEG", 8, 5, 80, 18, "LogoImage","SLOW"); 

    // canadian flag: https://cdn.shopify.com/s/files/1/0251/9964/0648/files/canadian_flag.png?v=1738765184
    const flagUrl = "https://cdn.shopify.com/s/files/1/0251/9964/0648/files/canadian_flag.png?v=1738765184";
    const flagImage = await requestImage(flagUrl);
    // Convert the image to a data URL
    const canvasFlag = document.createElement('canvas');
    const ctxFlag = canvasFlag.getContext('2d');
    canvasFlag.width = flagImage.width;
    canvasFlag.height = flagImage.height;
    ctxFlag.drawImage(flagImage, 0, 0);

    // Add the image to the PDF
    doc.addImage(canvasFlag.toDataURL("image/png"), "JPEG", 160, 197, 35, 18, "FlagImage","SLOW");
    doc.setFontSize(9.5);
    doc.setFont("helvetica", "normal");
    doc.text("100% Canadian Owned", 159, 220, { maxWidth: 45 });

    // 3. Product description
    doc.setFont("helvetica", "normal");
    doc.setFontSize(14);

    let pdf_desc = dataMetafields.variant_description
      ? dataMetafields.variant_description
      : "Information not available";

    doc.setFontSize(10);
    const maxWidth = 180;
    pdf_desc = pdf_desc.replace(/″/g, "\"");
    const lines = doc.splitTextToSize(pdf_desc, maxWidth);
    // console.log("lines: ", lines);
    doc.text(lines, 8, 30, { maxWidth });
    const internalLineHeightFactor = doc.internal.getLineHeightFactor();
    const internalFontSize = doc.internal.getFontSize();
    const linesLength = lines.length;
    let couterLine = 30 + linesLength * ( internalFontSize / internalLineHeightFactor); 

    // 4. Feature Image (if available)
    let newImgW, newImgH;
    if (imageUrl) {
      const image = await requestImage(imageUrl);
      const ctx = canvas.getContext("2d");
      canvas.width = image.width;
      canvas.height = image.height;
      ctx.drawImage(image, 0, 0);

      const imgScaleRatio = image.width / 100;
      newImgW = 100;
      newImgH = image.height / imgScaleRatio;

      if (newImgH > 100) {
        const adjustedRatio = newImgH / 100;
        newImgH = 100;
        newImgW = newImgW / adjustedRatio;
      }

      // Insert feature image into PDF
      doc.addImage(canvas.toDataURL("image/png"), "JPEG", 110, couterLine - 5, newImgW, newImgH, "FeatureImage","SLOW");

      // Image disclaimer
      doc.setFontSize(8);
      if (hasFeatureImage) {
        doc.text("NOTE: Image may not reflect selected features.", 130, newImgH + couterLine + 10);
      }
    }

    couterLine += 5;
    doc.setFontSize(10);

    // 5. Write section1Data (including "Finish" image if exists)
    let feltSwatchRendered = false;
    const hasShadeRow = section1Data.some((it) => it.key === "Shade");

    // Renders the felt swatch image with the same size/style and rulings
    // (line spacing) as the Finish swatch.
    async function addFeltSwatch(lead = 4) {
      feltSwatchRendered = true;
      couterLine += lead;
      // Caption the swatch with the felt swatch name, matching the
      // bold-label (x=8) / normal-value (x=57) row style used elsewhere.
      if (feltSwatchText) {
        doc.setFont("helvetica", "bold");
        doc.text("Felt Swatch:", 8, couterLine, { maxWidth: 180 });
        doc.setFont("helvetica", "normal");
        doc.text(String(feltSwatchText).replace(/″/g, '"'), 57, couterLine);
        couterLine += 2;
      }
      try {
        await loadAndAddFinishImage(doc, feltSwatchImageUrl, 8, couterLine, 180, "FeltSwatchImage");
        couterLine += 8;
      } catch (error) {
        console.error("Failed to load and add felt swatch image:", error);
      }
    }

    for (let index = 0; index < section1Data.length; index++) {
      const item = section1Data[index];

      // Render the felt swatch block right BEFORE the Shade row, so the
      // "Felt Swatch:" label + image sit above the product's "Shade:" line.
      if (!feltSwatchRendered && feltSwatchImageUrl && item.key === "Shade") {
        await addFeltSwatch();
        couterLine += 6;
      }

      // If there is no Shade row, keep the felt swatch in the same spot
      // (right after Finish, before the Lens rows) by rendering it just
      // before the first "Lens" row instead of after the whole section.
      if (!hasShadeRow && !feltSwatchRendered && feltSwatchImageUrl && item.key.indexOf("Lens") !== -1) {
        await addFeltSwatch();
        couterLine += 6;
      }

      doc.setFont("helvetica", "bold");
      doc.text(`${item.key}:`, 8, couterLine, { maxWidth: 180 });
      doc.setFont("helvetica", "normal");

      let itemData = String(item.value).replace(/″/g, '"');
      doc.text(itemData, 57, couterLine);

      // Check for "Finish" to include swatch image
      if (item.key === "Finish") {
        couterLine += 2;
        const finishImageElement = document.querySelector("#row-finish-swatch-image img");
        if (finishImageElement) {
          const finishImageUrl = finishImageElement.src;
          try {
            await loadAndAddFinishImage(doc, finishImageUrl, 8, couterLine, 180);
            couterLine += 8;
          } catch (error) {
            console.error("Failed to load and add finish image:", error);
          }
        }
        // No Shade row -> stack the felt swatch under the Finish swatch (its
        // natural slot, before Lens). Leave a small gap so the "Felt Swatch:"
        // label isn't crowded against the Finish image.
        if (!hasShadeRow && feltSwatchImageUrl && !feltSwatchRendered) {
          await addFeltSwatch(6);
        }
      }

      couterLine += 6;
    }

    // 5b. Last resort: if neither a Shade nor a Lens row existed, still render it.
    if (feltSwatchImageUrl && !feltSwatchRendered) {
      await addFeltSwatch();
      couterLine += 6;
    }

    // 6. Write section2Data (including the disclaimer if hasDisclaimer)
    couterLine += 1;
    section2Data.forEach((item) => {
      if (item.key === "disclaimer" && hasDisclaimer) {
        doc.setFont("helvetica", "normal");
        const itemData = String(item.value).replace(/″/g, '"');
        doc.text(itemData, 8, couterLine, { maxWidth: 100 });
        couterLine += 13;
      } else {
        doc.setFont("helvetica", "bold");
        doc.text(`${item.key}:`, 8, couterLine, { maxWidth: 180 });
        doc.setFont("helvetica", "normal");
        const itemData = String(item.value).replace(/″/g, '"');
        doc.text(itemData, 57, couterLine);
        couterLine += 6;
      }
    });

    // 7. Write remaining sections (3 to 7)
    function writeSectionData(sectionData) {
      if (sectionData.length === 0) return;
      couterLine += 1;
      sectionData.forEach((item) => {
        doc.setFont("helvetica", "bold");
        doc.text(`${item.key}:`, 8, couterLine, { maxWidth: 180 });
        doc.setFont("helvetica", "normal");
        const itemData = String(item.value).replace(/″/g, '"');
        doc.text(itemData, 57, couterLine);
        couterLine += 6;
      });
    }

    writeSectionData(section3Data);
    writeSectionData(section4Data);
    writeSectionData(section5Data);
    writeSectionData(section6Data);
    writeSectionData(section7Data);

    // 8. Draw the table and form fields at bottom
    const startingPositionY = 223;
    const tableHeight = 60;
    const bottomPositionY = startingPositionY + tableHeight;

    // Draw horizontal lines for the table
    doc.line(8, startingPositionY, 195, startingPositionY); // top edge
    doc.line(8, startingPositionY + 6, 105, startingPositionY + 6); // under headers
    doc.line(8, bottomPositionY, 195, bottomPositionY); // bottom edge

    // Smaller cells on the right side
    const rightCells_VerticalSpacing = 10;
    function hLine(num) {
      return startingPositionY + rightCells_VerticalSpacing * num;
    }
    [1, 2, 3, 4, 5].forEach((n) => doc.line(105, hLine(n), 195, hLine(n)));

    // Draw vertical lines
    doc.line(8, startingPositionY, 8, bottomPositionY);
    doc.line(45, startingPositionY, 45, bottomPositionY);
    doc.line(65, startingPositionY, 65, bottomPositionY);
    doc.line(105, startingPositionY, 105, bottomPositionY);
    doc.line(195, startingPositionY, 195, bottomPositionY);

    // Table text
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");

    const textHeadingPositionY = startingPositionY + 4;

    // Left table columns (Reference, Quantity, Remarks)
    doc.text("Reference", 9, textHeadingPositionY);
    const textFieldReference = new doc.AcroFormTextField();
    textFieldReference.fieldName = "reference";
    textFieldReference.Rect = [9, textHeadingPositionY + 3, 35, 53];  
    textFieldReference.multiline = true;
    doc.addField(textFieldReference);   

    doc.text("Quantity", 47, textHeadingPositionY);
    const textFieldQuantity = new doc.AcroFormTextField();
    textFieldQuantity.fieldName = "quantity";
    textFieldQuantity.Rect = [46, textHeadingPositionY + 3, 19, 53];
    textFieldQuantity.multiline = true;
    doc.addField(textFieldQuantity);

    doc.text("Remarks", 67, textHeadingPositionY);
    const textFieldRemarks = new doc.AcroFormTextField();
    textFieldRemarks.fieldName = "remarks";
    textFieldRemarks.Rect = [66, textHeadingPositionY + 3, 39, 53];
    textFieldRemarks.multiline = true;
    doc.addField(textFieldRemarks);

    // Right table columns (Project, Location, Architect, Engineer, Contractor, Submitted by, Date)
    doc.text("Project", 107, textHeadingPositionY);
    const textFieldProj = new doc.AcroFormTextField();
    textFieldProj.fieldName = "project";
    textFieldProj.Rect = [106, textHeadingPositionY + 1, 88, 5];
    doc.addField(textFieldProj);

    const rightStart = startingPositionY + 14;
    function rightLineY(offset) {
      return rightStart + offset;
    }

    doc.text("Location/Type", 107, rightLineY(0));
    const textFieldLoc = new doc.AcroFormTextField();
    textFieldLoc.fieldName = "location";
    textFieldLoc.Rect = [106, rightLineY(0) + 1, 88, 5];
    doc.addField(textFieldLoc);

    doc.text("Architect", 107, rightLineY(10));
    const textFieldArc = new doc.AcroFormTextField();
    textFieldArc.fieldName = "architect";
    textFieldArc.Rect = [106, rightLineY(10) + 1, 88, 5];
    doc.addField(textFieldArc);

    doc.text("Engineer", 107, rightLineY(20));
    const textFieldEng = new doc.AcroFormTextField();
    textFieldEng.fieldName = "engineer";
    textFieldEng.Rect = [106, rightLineY(20) + 1, 88, 5];
    doc.addField(textFieldEng);

    doc.text("Contractor", 107, rightLineY(30));
    const textFieldContr = new doc.AcroFormTextField();
    textFieldContr.fieldName = "contractor";
    textFieldContr.Rect = [106, rightLineY(30) + 1, 88, 5];
    doc.addField(textFieldContr);

    doc.text("Submitted by:", 107, rightLineY(40));
    const textFieldSubm = new doc.AcroFormTextField();
    textFieldSubm.fieldName = "submitted";
    textFieldSubm.Rect = [106, rightLineY(40) + 1, 52, 5];
    doc.addField(textFieldSubm);

    doc.text("Date:", 160, rightLineY(40));
    const textFieldDate = new doc.AcroFormTextField();
    textFieldDate.fieldName = "date";
    textFieldDate.Rect = [160, rightLineY(40) + 1, 34, 5];
    doc.addField(textFieldDate);

    // 9. Footer
    doc.setFont("helvetica", "normal");
    doc.text(
      "Unit 706-19055 Airport Way, Pitt Meadows, BC. V3Y 0G4     P:604 461 4747     F:604 461 5747     info@maxilite.net",
      20,
      290
    );

    // 10. Save PDF
    if (productPdfSku) {
      doc.save(`${productPdfSku}-Spec-Sheet.pdf`);
    } else {
      doc.save("Maxilite-Spec-Sheet.pdf");
    }
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
}



function getMetafieldData() {
  //Extracting Meafield Data:
 // console.log("Extracting Metafield Data:");
  const metafieldHTML = document.getElementById("maxi-metafield");
  if (!metafieldHTML) {
    console.error("Element 'maxi-metafield' not found");
    return null;
  }

  const metafieldText = metafieldHTML.textContent || metafieldHTML.innerHTML;
  const metafieldObject = JSON.parse(metafieldText);
  //console.log("Returning Meatafield data"); // This will log the parsed object to the console
  return metafieldObject;
}


function getFeaturedMedia() {
  const featuredMediaData = document.getElementById("testing_data_media");
 // console.log("Featured media: ", featuredMediaData);
  if (featuredMediaData) {
    const mediaId = featuredMediaData.getAttribute("data-media-id");

   // console.log("Media ID:", mediaId);
    return mediaId;
  } else {
  //  console.log("Element testing_data_media not found");
    return null;
  }
}

function getFeaturedImage() {
 // console.log("Getting Featured Image");

  const featuredImageHtml = document.getElementById(
    "featured-image-variant-data"
  );
  if (!featuredImageHtml) {
    console.error("Element 'featured-image-variant-data' not found");
    return { imageUrl: null, hasFeatureImage: null };
  }

  const featuredImageParagraph_one =
    featuredImageHtml.querySelector("p:first-of-type");
  const featuredImageParagraph_two =
    featuredImageHtml.querySelector("p:last-of-type");
  if (!featuredImageParagraph_one || !featuredImageParagraph_two) {
    console.error(
      "Failed to find the required paragraphs in 'featured-image-variant-data'"
    );
    return { imageUrl: null, hasFeatureImage: null };
  }

  const featuredImage_type =
    featuredImageParagraph_one.textContent ||
    featuredImageParagraph_one.innerHTML;
  const featuredImage_src =
    featuredImageParagraph_two.textContent ||
    featuredImageParagraph_two.innerHTML;

  if (
    featuredImage_type == "product.featured_image" ||
    featuredImage_type ==
      "product.selected_or_first_available_variant.featured_image"
  ) {
    const imageUrl = `https://cdn.shopify.com/s/files/1/0251/9964/0648/${featuredImage_src}`;
    const hasFeatureImage = true;
  //  console.log("Product has featured image");
   // console.log("type of featured image: ", featuredImage_type);
   // console.log(imageUrl);
    return { imageUrl, hasFeatureImage };
  } else {
    const imageUrl =
      "https://cdn.shopify.com/s/files/1/0251/9964/0648/files/spec-sheet-default-img.jpg";
    console.log("Not Product featured image");
    const hasFeatureImage = false;
    console.log(imageUrl);
    return { imageUrl, hasFeatureImage };
  }
}

let currentStateTable;

const styleSpecsTableModule = (function() {
  currentStateTable = false;
  const showMore_Boton = document.getElementById("btn-prueba");
  const table_Contenedor = document.getElementById("tabla--div");
  const iconsContainer = document.getElementById("prueba--icon");
  const more_resources = document.querySelector(".mas-recursos");
  const specsLoader = document.getElementById("loader_desc");
  const specsTable = document.getElementById("product-specs-table");

  more_resources.classList.add("shadow");
  table_Contenedor.style.overflow = "hidden";
  table_Contenedor.classList.add("spects--cerrado");
  toggleIcons(false);

  function hideLoader() {
    if (specsLoader && !specsLoader.classList.contains("visually-hidden")) {
      specsLoader.classList.add("visually-hidden");
      specsTable.classList.remove("visually-hidden");
    }
  }

  function toggleIcons(open) {
    iconsContainer.classList.toggle("gg-chevron-down", !open);
    iconsContainer.classList.toggle("gg-chevron-up", open);
  }

  function close_tablespecs() {
      more_resources.classList.toggle("shadow", true);
      // table_Contenedor.style.maxHeight = "375px";
      table_Contenedor.style.maxHeight = "375px";
      table_Contenedor.classList.add("spects--cerrado");
      toggleIcons(false);
      showMore_Boton.textContent = "Show More";

    // Get the top position of the #button-close-quote-form element
     let containerTop = $("#block_specsTable").offset().top;
     let offset = 50; // Adjust this value to match your navbar height
     let scrollTo = containerTop - offset; // Calculate the final scroll position


       $('html, body').animate({
         scrollTop: scrollTo
       }, 'slow');
    
  }
  
  function open_tablespecs() {
    table_Contenedor.style.maxHeight = table_Contenedor.scrollHeight + "px";
    table_Contenedor.classList.remove("spects--cerrado");
    toggleIcons(true);
    showMore_Boton.textContent = "Show Less";
    setTimeout(() => {
      more_resources.classList.toggle("shadow", false);
    }, 800);
    
  }

  function styleSpecsTable() {
      // Staring code...
      //loading handler when first loading product page
      hideLoader();

      showMore_Boton.addEventListener("click", () => {
        if (currentStateTable) {
          close_tablespecs()
        } else {
          open_tablespecs()
        }
        currentStateTable = !currentStateTable; // Toggle the state
        console.log("Toggle table: ", currentStateTable);
      });
  }


  // Exposing methods..
  return {
      initialize: styleSpecsTable,
      closeSpecs: close_tablespecs,
      openSpecs: open_tablespecs
  };
})();



 async function getProductPageAttributes() {
    const productPageData = document.getElementById('product-page_data');
    
    if (!productPageData) {
        return {
            currentVariant: null,
            sectionId: null
        }
    }

    const currentVariant = productPageData.getAttribute("current-variant") || null;
    const sectionId = productPageData.getAttribute("section-id") || null;

    return {
        currentVariant: currentVariant,
        sectionId: sectionId
    };
}

function getSkuData() {
    const maxiliteSkuData = document.getElementById('maxi-product-sku');
    
    if (!maxiliteSkuData) {
        return null;
    }

    const skudata = maxiliteSkuData.textContent || maxiliteSkuData.innerHTML;
    const skuObject = JSON.parse(skudata);

    // If you want to log the value, you can uncomment the line below
    // console.log(skuObject);

    return skuObject;
}

function click_requestquote(){
  update_quoteform();
  $("#quoteform").slideToggle();
}

// getAllFilesFromServer() lived here. It pulled a full file manifest from
// bun-files-server-cache.maxilitecloudsolutions.store/gather-all-files and held
// it in localStorage for 30 minutes. checkFileExists() was its only caller and
// now checks the origin live through the proxy, so it has been removed.
// The stale 'maxilite_files_cache' localStorage key is harmless and expires on
// its own; nothing reads it any more.

document.addEventListener('DOMContentLoaded', async (event) => {
    
    const { currentVariant, sectionId } = await getProductPageAttributes();
    // console.log(sectionId);
    // console.log(currentVariant);

    const skuData = await getSkuData();
    // console.log(skuData);

    const cv_specs = await getMetafieldData();
    // console.log(cv_specs);

    // Button - close the quote form
    $("#button-close-quote-form").click(function (event) {
      event.preventDefault();

      // Get the top position of the #button-close-quote-form element
      let containerTop = $(".customization-promotion").offset().top;
      let offset = 50; // Adjust this value to match your navbar height
      let scrollTo = containerTop - offset; // Calculate the final scroll position

      $("#quoteform").slideUp("slow", function(){
        $('html, body').animate({
          scrollTop: scrollTo
        }, 'slow');

      });
      });

    if(currentVariant && cv_specs){
        const blockSpecsTable = document.getElementById('spects--id');
        if(blockSpecsTable){
           assingSpecsData();
           styleSpecsTableModule.initialize();
           const pdfElementConteiner = document.querySelector('#pdf-container-download a');
          //  console.log("Adding event listener to pdf download button");
           if(pdfElementConteiner){
               pdfElementConteiner.addEventListener('click', function(event){
                 event.preventDefault();
                 generatePDF();
               });
              }
        }

    }


    if (typeof window.subscribe === 'function') {
        const logVariantChangeMiddleware = async (event) => {
            // console.log('variantChange event data MiddleWare:', event);
            // Accessing properties of the data object
            // console.log('Variant:', event.data.variant);
            const blockAppVariant = event.data.variant.id;
            // console.log('Event:', event);

            const html = event.data.html;
    
            // console.log("New path: ");
            // console.log(window.location.pathname);
            // console.log(window.location.search);
           
            const blockSectionDiv = document.getElementById('product-page_data');
            if(blockSectionDiv){
                        const pageDataSource = html.getElementById("product-page_data");
                        const pageDataDestination = document.getElementById("product-page_data");
    
                        if(pageDataSource && pageDataDestination) {
                            pageDataDestination.innerHTML = pageDataSource.innerHTML;
                        }
                        const blockSpecsTable = document.getElementById('block_specsTable');
                        if(blockSpecsTable){
                                      
                          if(currentStateTable){
                            styleSpecsTableModule.closeSpecs();
                            currentStateTable = !currentStateTable;
                          }
                          
                            clearDataSpecsTable();
                            cleanupDownloadButtons();
                            assingSpecsData();
                        }
            }
            // console.log("Section id:", sectionId);
            const blockQuickShipSource = html.getElementById(`maxilite-quickship-box-${sectionId}`)
            const blockQuickShipDestination = document.getElementById(`maxilite-quickship-box-${sectionId}`);
            if(blockQuickShipSource && blockQuickShipDestination){
              // console.log("QuickShip variant change:");
              blockQuickShipDestination.innerHTML = blockQuickShipSource.innerHTML;
            }

            const blockInventoryStockSource = html.getElementById(`inventory-stock-box-${sectionId}`);
            const blockInventoryStockDestination = document.getElementById(`inventory-stock-box-${sectionId}`);
            if (blockInventoryStockSource && blockInventoryStockDestination) {
              blockInventoryStockDestination.innerHTML = blockInventoryStockSource.innerHTML;
            }

            const blockGtinSource = html.getElementById(`product-gtin-${sectionId}`);
            const blockGtinDestination = document.getElementById(`product-gtin-${sectionId}`);
            if (blockGtinSource && blockGtinDestination) {
              blockGtinDestination.innerHTML = blockGtinSource.innerHTML;
            }

          };
          

          const unsubscribeMiddleware = window.subscribe('variant-change', logVariantChangeMiddleware);
          window.onbeforeunload = () => {
            // console.log('unsubscribeMiddleware');
            unsubscribeMiddleware();
          };
    
    } else {
        console.error('window.subscribe is not available after DOMContentLoaded.');
    }
    

});